import {NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {TranslationWidth} from "@angular/common";
import {Injectable} from "@angular/core";
import {TranslocoService} from "@ngneat/transloco";

@Injectable({ providedIn:'root' })
export class CustomNgbDatepickerI18n extends NgbDatepickerI18n {

  constructor(private translocoService: TranslocoService) {
    super();
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return "";
  }

  getMonthFullName(month: number, year?: number): string {
    switch (month) {
      case 1:
        return this.translocoService.translate('months.picker.january');
      case 2:
        return this.translocoService.translate('months.picker.february');
      case 3:
        return this.translocoService.translate('months.picker.march');
      case 4:
        return this.translocoService.translate('months.picker.april');
      case 5:
        return this.translocoService.translate('months.picker.may');
      case 6:
        return this.translocoService.translate('months.picker.june');
      case 7:
        return this.translocoService.translate('months.picker.july');
      case 8:
        return this.translocoService.translate('months.picker.august');
      case 9:
        return this.translocoService.translate('months.picker.september');
      case 10:
        return this.translocoService.translate('months.picker.october');
      case 11:
        return this.translocoService.translate('months.picker.november');
      case 12:
        return this.translocoService.translate('months.picker.december');
    }
    return "";
  }

  getMonthShortName(month: number, year?: number): string {
    switch (month) {
      case 1:
        return this.translocoService.translate('months.picker.short.january');
      case 2:
        return this.translocoService.translate('months.picker.short.february');
      case 3:
        return this.translocoService.translate('months.picker.short.march');
      case 4:
        return this.translocoService.translate('months.picker.short.april');
      case 5:
        return this.translocoService.translate('months.picker.short.may');
      case 6:
        return this.translocoService.translate('months.picker.short.june');
      case 7:
        return this.translocoService.translate('months.picker.short.july');
      case 8:
        return this.translocoService.translate('months.picker.short.august');
      case 9:
        return this.translocoService.translate('months.picker.short.september');
      case 10:
        return this.translocoService.translate('months.picker.short.october');
      case 11:
        return this.translocoService.translate('months.picker.short.november');
      case 12:
        return this.translocoService.translate('months.picker.short.december');
    }
    return "";
  }

  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    switch (weekday) {
      case 1:
        return this.translocoService.translate('days.of.the.week.picker.monday');
      case 2:
        return this.translocoService.translate('days.of.the.week.picker.tuesday');
      case 3:
        return this.translocoService.translate('days.of.the.week.picker.wednesday');
      case 4:
        return this.translocoService.translate('days.of.the.week.picker.thursday');
      case 5:
        return this.translocoService.translate('days.of.the.week.picker.friday');
      case 6:
        return this.translocoService.translate('days.of.the.week.picker.saturday');
      case 7:
        return this.translocoService.translate('days.of.the.week.picker.sunday');
    }
    return "";
  }
}

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomNgbDatepickerAdapter extends NgbDateAdapter<Date> {

  fromModel(value: Date | null): NgbDateStruct | null {
    if (value && this.isValidDate(value)) {
      return {
        day: value.getDate(),
        month: value.getMonth() + 1,
        year: value.getFullYear(),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): Date | null {
    if (date?.year && date.month && date.day) {
      return new Date(date?.year, date?.month - 1, date?.day);
    }
    return null;
  }

  isValidDate(date: any): boolean {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomNgbDatepickerDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER_SLASH = '/';
  readonly DELIMITER_DOT = '.';

  constructor(private translocoService: TranslocoService) {
    super();
  }

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date: string[] = value.split(this.getDelimiter());
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.getDelimiter() + date.month + this.getDelimiter() + date.year : '';
  }

  getDelimiter(): string {
    if (this.translocoService.getActiveLang() === 'hr' || this.translocoService.getActiveLang() === 'slo') {
      return this.DELIMITER_DOT;
    }
    return this.DELIMITER_SLASH;
  }
}

